import { render } from "./SubscriptionBest2Pay.vue?vue&type=template&id=3f2c84f5"
import script from "./SubscriptionBest2Pay.vue?vue&type=script&lang=js"
export * from "./SubscriptionBest2Pay.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__